import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcessStdBuExportStatus: 'idle',
    startProcessStdBuExportError: undefined as any,
    loadUserParamsProcessStdBuExportStatus: 'idle',
    loadUserParamsProcessStdBuExportError: undefined as any,

    processStdBuExportList: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcessStdBuExport = createAsyncThunk('processStdBuExportSlice/startProcessStdBuExport', async ({ processStdBuExport }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcessStdBuExport/`,
        prepareData(processStdBuExport),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcessStdBuExportStatus } = getState().processStdBuExportSlice
        return startProcessStdBuExportStatus !== 'pending'
    }
})

export const loadUserParamsProcessStdBuExport = createAsyncThunk('processStdBuExportSlice/loadUserParamsProcessStdBuExport', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcessStdBuExport/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcessStdBuExportStatus } = getState().processStdBuExportSlice
        return loadUserParamsProcessStdBuExportStatus !== 'pending'
    }
})

const ProcessStdBuExportSlice = createSlice({
    name: 'processStdBuExportSlice',
    initialState,
    reducers: {
        resetstartProcessStdBuExport: (state) => {
            state.job = undefined
            state.startProcessStdBuExportError = undefined
        },
        resetstartProcessStdBuExportError: (state) => {
            state.startProcessStdBuExportError = undefined
        },
        resetloadUserParamsProcessStdBuExport: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcessStdBuExportError = undefined
        },
        resetloadUserParamsProcessStdBuExportError: (state) => {
            state.loadUserParamsProcessStdBuExportError = undefined
        },
        removeFromProcessStdBuExportListById: (state, action) => {
            state.processStdBuExportList = state.processStdBuExportList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcessStdBuExportListByIds: (state, action) => {
            state.processStdBuExportList = state.processStdBuExportList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.processStdBuExportList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcessStdBuExportStatus = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.processStdBuExportList = []
            state.startProcessStdBuExportStatus = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcessStdBuExport.pending, (state) => {
            state.startProcessStdBuExportStatus = 'pending'
            state.startProcessStdBuExportError = undefined
        })
        builder.addCase(startProcessStdBuExport.fulfilled, (state, action) => {
            state.startProcessStdBuExportStatus = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcessStdBuExport.rejected, (state, action) => {
            state.startProcessStdBuExportStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcessStdBuExportError = action.error.message
            } else {
                state.startProcessStdBuExportError = action.payload
            }
        })

        builder.addCase(loadUserParamsProcessStdBuExport.pending, (state) => {
            state.loadUserParamsProcessStdBuExportStatus = 'pending'
            state.loadUserParamsProcessStdBuExportError = undefined
        })
        builder.addCase(loadUserParamsProcessStdBuExport.fulfilled, (state, action) => {
            state.loadUserParamsProcessStdBuExportStatus = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcessStdBuExport.rejected, (state, action) => {
            state.loadUserParamsProcessStdBuExportStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcessStdBuExportError = action.error.message
            } else {
                state.loadUserParamsProcessStdBuExportError = action.payload
            }
        })

    }
})

export const {
    resetstartProcessStdBuExport,
    resetstartProcessStdBuExportError,
    resetloadUserParamsProcessStdBuExport,
    resetloadUserParamsProcessStdBuExportError,
    removeFromProcessStdBuExportListById,
    removeFromProcessStdBuExportListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = ProcessStdBuExportSlice.actions
export default ProcessStdBuExportSlice.reducer
